module.exports = __webpack_public_path__ + "static/media/f_faceshape_v_vector.797e6d00.svg";